export default "__VITE_ASSET__Dj4l2yNE__"